import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69e14b75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "message-btns" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-invite" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "message-btns" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-invite" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_invitations = _resolveComponent("spaces-invitations")!
  const _component_spaces_my = _resolveComponent("spaces-my")!
  const _component_spaces_outcoming = _resolveComponent("spaces-outcoming")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!
  const _component_app_no_message = _resolveComponent("app-no-message")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.spacesStore.search)
          ? (_openBlock(), _createBlock(_component_refresh_pull, {
              key: 0,
              modelValue: _ctx.loadingPull,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loadingPull) = $event)),
              onRefresh: _ctx.onRefresh,
              successText: _ctx.successText,
              pullingText: _ctx.pullingText,
              loosingText: _ctx.loosingText,
              loadingText: _ctx.loadingText
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_2, [
                    (_ctx.mainStore.isNative)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "tell-a-friend",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.shareApp && _ctx.shareApp(...args)))
                        }, [
                          _hoisted_3,
                          _createElementVNode("p", null, _toDisplayString(_ctx.$localize('app.menu.share_app')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.isManageContacts && _ctx.spacesStore.filteredInvitationsContact.length)
                    ? (_openBlock(), _createBlock(_component_spaces_invitations, {
                        key: 0,
                        invitations: _ctx.spacesStore.filteredInvitationsContact
                      }, null, 8, ["invitations"]))
                    : _createCommentVNode("", true),
                  (_ctx.spacesStore.filteredMyContacts.length)
                    ? (_openBlock(), _createBlock(_component_spaces_my, {
                        key: 1,
                        class: "mb-30"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isManageContacts && _ctx.spacesStore.filteredOutgoingContact.length)
                    ? (_openBlock(), _createBlock(_component_spaces_outcoming, {
                        key: 2,
                        "outgoing-list": _ctx.spacesStore.filteredOutgoingContact
                      }, null, 8, ["outgoing-list"]))
                    : _createCommentVNode("", true),
                  _hoisted_4
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText"]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "scroller",
              ref: "scroller",
              onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
            }, [
              (_ctx.myContactsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myContactsSearch, (contact) => {
                        return (_openBlock(), _createBlock(_component_spaces_user, {
                          key: (contact.accountId + contact.contactStatus),
                          user: contact,
                          userType: _ctx.resolveUserType(contact.contactStatus, contact.accountId)
                        }, null, 8, ["user", "userType"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.notMyContactsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 1 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.other')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notMyContactsSearch, (contact) => {
                        return (_openBlock(), _createBlock(_component_spaces_user, {
                          key: contact.accountId + contact.contactStatus,
                          user: contact,
                          userType: _ctx.resolveUserType(contact.contactStatus, contact.accountId)
                        }, null, 8, ["user", "userType"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_app_no_message, {
                icon: _ctx.noDataMessage.icon
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.noDataMessage.text), 1)
                ]),
                _: 1
              }, 8, ["icon"]), [
                [_vShow, !_ctx.spacesStore.dataLoading  && !_ctx.spacesStore.searchContactsList.length]
              ]),
              _hoisted_5
            ], 544))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        (!_ctx.spacesStore.search)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.mainStore.isNative)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "tell-a-friend",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.shareApp && _ctx.shareApp(...args)))
                    }, [
                      _hoisted_9,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('app.menu.share_app')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isManageContacts && _ctx.spacesStore.filteredInvitationsContact.length)
                ? (_openBlock(), _createBlock(_component_spaces_invitations, {
                    key: 0,
                    invitations: _ctx.spacesStore.filteredInvitationsContact
                  }, null, 8, ["invitations"]))
                : _createCommentVNode("", true),
              (_ctx.spacesStore.filteredMyContacts.length)
                ? (_openBlock(), _createBlock(_component_spaces_my, {
                    key: 1,
                    class: "mb-30"
                  }))
                : _createCommentVNode("", true),
              (_ctx.isManageContacts && _ctx.spacesStore.filteredOutgoingContact.length)
                ? (_openBlock(), _createBlock(_component_spaces_outcoming, {
                    key: 2,
                    "outgoing-list": _ctx.spacesStore.filteredOutgoingContact
                  }, null, 8, ["outgoing-list"]))
                : _createCommentVNode("", true),
              _hoisted_10
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "scroller",
              ref: "scroller",
              onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
            }, [
              (_ctx.myContactsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 0 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.contacts')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myContactsSearch, (contact) => {
                        return (_openBlock(), _createBlock(_component_spaces_user, {
                          key: (contact.accountId + contact.contactStatus),
                          user: contact,
                          userType: _ctx.resolveUserType(contact.contactStatus, contact.accountId)
                        }, null, 8, ["user", "userType"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.notMyContactsSearch.length)
                ? (_openBlock(), _createBlock(_component_app_item_wrapper, { key: 1 }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$localize('contacts.my.other')), 1)
                    ]),
                    main: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notMyContactsSearch, (contact) => {
                        return (_openBlock(), _createBlock(_component_spaces_user, {
                          key: contact.accountId + contact.contactStatus,
                          user: contact,
                          userType: _ctx.resolveUserType(contact.contactStatus, contact.accountId)
                        }, null, 8, ["user", "userType"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_11
            ], 544))
      ]))
}